<div style="display: flex; height: 100vh;">
  <app-sidebar></app-sidebar>
  <main style="flex: 1;height: 100vh;overflow-y: auto;overflow-x: hidden;">
    <app-profile-icon></app-profile-icon>
    <router-outlet></router-outlet>
  </main>
</div>
